import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, MapPin } from "lucide-react";
import { BRAND } from "../data";

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="relative z-10 bg-[#080808] border-t border-stone-800 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="font-serif text-2xl text-white">{BRAND.name}</div>
          <div className="text-[10px] uppercase tracking-[0.35em] text-gold mt-1 mb-5">
            {BRAND.suffix}
          </div>
          <p className="text-stone-400 text-sm leading-relaxed max-w-xs">
            Fotografo di matrimoni, eventi e compleanni nella Tuscia Viterbese e a Roma.
            Studio fotografico con base a Faleria, Viterbo.
          </p>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-stone-300 mb-5">Naviga</h4>
          <ul className="space-y-3 text-sm text-stone-400">
            <li><Link to="/" className="hover:text-gold transition-colors">Home</Link></li>
            <li><Link to="/chi-sono" className="hover:text-gold transition-colors">Chi Sono</Link></li>
            <li><Link to="/servizi" className="hover:text-gold transition-colors">Servizi & Pacchetti</Link></li>
            <li><Link to="/contatti" className="hover:text-gold transition-colors">Contatti</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-stone-300 mb-5">Contatti</h4>
          <ul className="space-y-4 text-sm text-stone-400">
            <li className="flex items-center gap-3">
              <MapPin size={16} className="text-gold shrink-0" /> {BRAND.base}
            </li>
            <li>
              <a href={`tel:${BRAND.phoneIntl}`} data-testid="footer-phone" className="flex items-center gap-3 hover:text-gold transition-colors">
                <Phone size={16} className="text-gold shrink-0" /> {BRAND.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${BRAND.email}`} data-testid="footer-email" className="flex items-center gap-3 hover:text-gold transition-colors">
                <Mail size={16} className="text-gold shrink-0" /> {BRAND.email}
              </a>
            </li>
            <li>
              <a href={BRAND.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="flex items-center gap-3 hover:text-gold transition-colors">
                <Instagram size={16} className="text-gold shrink-0" /> {BRAND.instagramHandle}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-14 pt-6 border-t border-stone-900 flex flex-col md:flex-row items-center justify-between gap-3">
        <p className="text-xs text-stone-500">
          © {new Date().getFullYear()} {BRAND.name} {BRAND.suffix}. Tutti i diritti riservati.
        </p>
        <a href="/admin" data-testid="footer-admin-link" className="text-xs text-stone-600 hover:text-stone-400 transition-colors">
          Area Riservata
        </a>
      </div>
    </footer>
  );
};

export default Footer;
